// Error Types
export const msgTypes = {
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS'
}

// Notification Types (Follow backend enum data)
export const notifyTypes = {
  SYS_MESSAGE: 'System Notification',
  APP_MESSAGE: 'System Notification', // What should be the notify description?
  MOTORPROPOSAL_STATUS: 'Motor Quotation/Proposal',
  TRVPROPOSAL_STATUS: 'Travel Quotation/Proposal',
  FIREPROPOSAL_STATUS: 'Fire Quotation/Proposal',
  CARGOPROPOSAL_STATUS: 'Cargo Quotation/Proposal',
  MAIDPROPOSAL_STATUS: 'Maid Quotation/Proposal',
  PKGPROPOSAL_STATUS: 'Package Quotation/Proposal',
  CLAIM_STATUS: 'Claim'
}

// Key to decode localstorage content
export const mavKey = 'maverick-c9sg'
